import { action, makeObservable, observable } from 'mobx';

class GameScene {
  start = false;

  main = false;

  finish = false;

  constructor() {
    makeObservable(this, {
      start: observable,
      main: observable,
      finish: observable,
      setGameStart: action.bound,
      setGameMain: action.bound,
      setGameFinish: action.bound,
    });
  }

  setGameStart(odd) {
    this.start = odd;
    this.finish = false;
  }

  setGameMain(odd) {
    this.main = odd;
    this.start = false;
  }

  setGameFinish(bool) {
    this.finish = bool;
    this.main = false;
  }
}

export const gameSceneStore = new GameScene();
